import { IConsumptionSafeguardDTO } from "@/interface"
import { convertCentsToEuros } from "@/mega-ui/helpers/function/convertCentsToEuros"

export class ConsumptionSafeguard {

    public current: number;
    public next: number;
    public alert: number;
    public default: number;
    public max: number;

    constructor(base?: Partial<ConsumptionSafeguard>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IConsumptionSafeguardDTO): ConsumptionSafeguard {
        return new ConsumptionSafeguard({
            current: convertCentsToEuros(dto.current),
            next: convertCentsToEuros(dto.next),
            alert: convertCentsToEuros(dto.alert),
            default: dto.default ? convertCentsToEuros(dto.default) : 0,
            max: convertCentsToEuros(dto.max)
        });
    }
}
